import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { GetLocalStorage } from "../../../../components/commonClass/Session";
import { getAllData } from "../../../../services/ApiCallingUserServices";
import { loaderActions } from "../../../../_actions/loader.actions";
import { alphaNumeric, alphaNumericWithSpace, isValidPAN, onlyAlphabets, onlyNumeric } from "../../../../components/commonClass/CommonValidation";


const HotelAddTravellerForm = (props: any) => {

    const {
        setFormValue,
        formValue,
        setFormError,
        formError,
        setInsertCollection,
        insertCollection,
        setInitialData,
        initialData,
        setIntOtherData,
        intOtherData,
        handleContinue,
        setPassengersData,
        hoteldata,
    } = props;
    sessionStorage?.setItem("isHotelPurchase", "false")
    const dispatch = useDispatch();
    const location = useLocation();
    const APIBadMessage = 'Something went wrong, Please try again!'
    const [dropdownData, setDropdownData] = useState<any>({});
    const [personcount, setPersonCont] = useState<any>({});

    const titleList = [
        { value: 1, label: "Mr" },
        { value: 2, label: "Mrs" },
        { value: 3, label: "Miss" },
        { value: 4, label: "Ms" }
    ]

    const genderList = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
    ]

    const [searchParams, setSearchParams] = useSearchParams();
    const isinternationalhotel = sessionStorage?.getItem('isinternationalhotel') === 'true' ? true : false;

    const showPAN = (CountryId: any) => {
        return [1]?.includes(CountryId) && isinternationalhotel;
    }

    const showPassport = (CountryId: any) => {
        return isinternationalhotel ? true : ![0, 1]?.includes(CountryId);
    }

    useEffect(() => {
        if (intOtherData !== formValue && formValue !== null) {
            sessionStorage.setItem('tvldata', JSON.stringify(formValue))
        }
    }, [intOtherData, formValue])

    useEffect(() => {
        if (initialData !== insertCollection && insertCollection !== null) {
            sessionStorage.setItem('datas', JSON.stringify(insertCollection))
            setFormValue((form: any) => ({ ...form, PersonCollection: insertCollection }))
            setPassengersData(insertCollection, false)
        }
    }, [insertCollection, initialData])

    const defaultForm = {
        Title: "",
        TitleId: 0,
        FirstName: "",
        LastName: "",
        Gender: 0,
        DateOfBirth: null,
        tempDOB: '',
        CountryId: 0,
        CountryCode: '',
        CountryName: '',
        CellCountryCode: '',
        Nationality: '',
        Phoneno: '',
        Email: '',
        PassportNo: '',
        PassportIssueDate: null,
        tempPassportIssueDate: '',
        PassportExpDate: null,
        tempExpiryDate: '',
        PassportIssueCountryCode: '',
        PaxType: 0,
        LeadPassenger: false,
        Age: 0,
        PaxId: 0,
        GSTCompanyAddress: null,
        GSTCompanyContactNumber: null,
        GSTCompanyName: null,
        GSTNumber: null,
        GSTCompanyEmail: null,
        PAN: "",
    }

    const ageList = useMemo(() => {
        const ages = []
        for (let i = 13; i <= 100; i++) {
            ages?.push({ label: i, value: i });
        }
        return ages;
    }, [])

    const getdropdowndata = async () => {

        const travellerlistbyid: any = await getAllData(`/midoffice/v1/gettravelerprofilelist`)
        if (travellerlistbyid?.status) {
            setDropdownData((data: any) => ({ ...data, travellerList: travellerlistbyid?.data?.filter((el: any) => el.UserName?.trim()?.length > 0) }))
        }

        const territorydetails = await getAllData(`/customerui/v1/getterritorydetails`)
        if (territorydetails?.status) {
            setDropdownData((data: any) => ({ ...data, countryList: territorydetails?.data?.countryList }))
        }

        const apiCollections = [territorydetails];
        apiCollections?.forEach((element) => {
            if (!element?.status) {
                dispatch({ type: 'ALERTING', message: element?.message || APIBadMessage, redirectTo: '/' });
                dispatch(loaderActions.end());
            }
        })
    }

    //#region create adult, child and infant collection from theirs count
    useEffect(() => {
        const payloadObjs = {
            "PaxRooms": location?.state?.PaxRooms,
        };
        setPersonCont(payloadObjs)

        if (payloadObjs !== undefined) {
            const userData: any = GetLocalStorage();
            //#region adult, child and infant collection for insert, depend on their counts
            if (payloadObjs?.PaxRooms?.length > 0) {
                const obj = payloadObjs?.PaxRooms?.map((room: any, roomIndex: any) => {
                    const passengers = [];

                    // Adults
                    for (let i = 0; i < room.Adults; i++) {
                        if (i === 0) {
                            passengers.push({
                                ...defaultForm,
                                PaxType: 1,
                                id: i,
                                LeadPassenger: true
                            });
                        }
                        else {
                            passengers.push({
                                ...defaultForm,
                                PaxType: 1,
                                id: i,
                                LeadPassenger: false,
                            });
                        }
                    }

                    // Children
                    for (let i = 0; i < room.Children; i++) {
                        passengers.push({
                            ...defaultForm,
                            PaxType: 2,
                            id: i,
                            Age: room?.ChildrenAges[i] ? room?.ChildrenAges[i] : 0
                        });
                    }
                    return { HotelPassenger: passengers };
                })
                //#endregion

                const bid = sessionStorage.getItem('bid') ? sessionStorage.getItem('bid') : null;
                const bookingId = location?.state?.BookingId;

                let datas: any = sessionStorage?.getItem('datas')
                let datainsert = JSON.parse(datas);
                setInitialData(obj);
                setInsertCollection((datainsert !== null && bid === bookingId) ? datainsert : JSON.parse(JSON.stringify(obj)));

                const formDetails = {
                    CountryId: 0,
                    CountryCode: '',
                    CountryName: '',
                    CellCountryCode: '',
                    Nationality: '',
                    FirstName: '',
                    LastName: '',
                    MobileNo: "",
                    Email: "",
                    // SpecialRequest: "",
                    IsGST: false,
                    GSTNumber: "",
                    GSTCompanyName: "",
                    GSTCompanyContactNumber: "",
                    GSTCompanyEmail: "",
                    GSTCompanyAddress: "",
                    UserId: userData?.userMasterID,
                    PanSameForAllPax: false
                }
                let tvldata: any = sessionStorage?.getItem('tvldata')
                let otherdatas = JSON.parse(tvldata);
                setIntOtherData(formDetails);
                setFormValue(bid === bookingId ? otherdatas : JSON.parse(JSON.stringify(formDetails)));

                if (bid !== bookingId) {
                    sessionStorage.setItem('bid', bookingId)
                    sessionStorage?.setItem('bookingId', searchParams?.get('code') || '');
                    sessionStorage.setItem('passengers', '')
                    sessionStorage.setItem('others', '')
                }
            }
        }
        getdropdowndata()
    }, [searchParams, location])

    //#endregion

    //#region date format function (yyyy-mm-dd) for insert collection
    function formatDate(date: any) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date === null ? null : [year, month, day].join('-');
    }
    //#endregion

    const handleSelectSuggestion = (coll: any, e: any, id: any, roomiondex: any) => {
        setFormError({});
        const travelerData = dropdownData?.travellerList?.find((obj: any) => obj?.UserMasterID === Number(e.target.value));
        if (coll === 'adult') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger: any = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 1) {
                        const titleData = titleList?.find((find: any) => find?.value === travelerData?.TravellerTitleId);
                        obj.TitleId = titleData?.value || 0;
                        obj.Title = titleData?.label || '';
                        obj.Gender = Number(travelerData?.TravellerTitleId) > 0 ? (Number(travelerData?.TravellerTitleId) === 1 ? 1 : 2) : 0;
                        obj.FirstName = travelerData?.FirstName ? travelerData?.FirstName : '';
                        obj.LastName = travelerData?.LastName ? travelerData?.LastName : '';
                        obj.TravelerName = Number(e.target.value);

                        const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.CountryId);
                        obj.CountryId = countryData?.CountryId || 0;
                        obj.CountryCode = countryData?.CountryCode || '';
                        obj.CountryName = countryData?.CountryName || '';
                        obj.CellCountryCode = countryData?.ISDCode || '';
                        obj.Nationality = countryData?.CountryCode || '';

                        obj.Email = travelerData?.UserEmail || '';
                        obj.Phoneno = travelerData?.ContactNo || '';

                        obj.PassportIssueCountryCode = (showPassport(countryData?.CountryId) && countryData?.CountryCode) || "";
                        obj.PassportNo = showPassport(countryData?.CountryId) && travelerData?.PassportNumber ? travelerData?.PassportNumber : "";
                        obj.PassportExpDate = showPassport(countryData?.CountryId) && travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) + "T00:00:00" : null;
                        obj.tempExpiryDate = showPassport(countryData?.CountryId) && travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) : "";
                        obj.PassportIssueDate = showPassport(countryData?.CountryId) && travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) + "T00:00:00" : null;
                        obj.tempPassportIssueDate = showPassport(countryData?.CountryId) && travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) : "";

                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });

        }
        else if (coll === 'child') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 2) {
                        const titleData = titleList?.find((find: any) => find?.value === travelerData?.TravellerTitleId);
                        obj.TitleId = titleData?.value || 0;
                        obj.Title = titleData?.label || '';
                        obj.Gender = Number(travelerData?.TravellerTitleId) > 0 ? (Number(travelerData?.TravellerTitleId) === 1 ? 1 : 2) : 0;
                        obj.FirstName = travelerData?.FirstName ? travelerData?.FirstName : '';
                        obj.LastName = travelerData?.LastName ? travelerData?.LastName : '';
                        obj.TravelerName = Number(e.target.value);

                        const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.CountryId);
                        obj.CountryId = countryData?.CountryId || 0;
                        obj.CountryCode = countryData?.CountryCode || '';
                        obj.CountryName = countryData?.CountryName || '';
                        obj.CellCountryCode = countryData?.ISDCode || '';
                        obj.Nationality = countryData?.CountryCode || '';

                        obj.PassportIssueCountryCode = (showPassport(countryData?.CountryId) && countryData?.CountryCode) || "";
                        obj.PassportNo = showPassport(countryData?.CountryId) && travelerData?.PassportNumber ? travelerData?.PassportNumber : "";
                        obj.PassportExpDate = showPassport(countryData?.CountryId) && travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) + "T00:00:00" : null;
                        obj.tempExpiryDate = showPassport(countryData?.CountryId) && travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) : "";
                        obj.PassportIssueDate = showPassport(countryData?.CountryId) && travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) + "T00:00:00" : null;
                        obj.tempPassportIssueDate = showPassport(countryData?.CountryId) && travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) : "";
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
    }


    //#region select title on chnage for collection
    const handleSelect = (coll: any, name: any, e: any, id: any, roomiondex: any) => {
        setFormError({});
        if (coll === 'adult') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 1) {
                        if (name === 'CountryId') {
                            const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));
                            obj.CountryId = countryData?.CountryId || 0;
                            obj.CountryCode = countryData?.CountryCode || "";
                            obj.CountryName = countryData?.CountryName || "";
                            obj.CellCountryCode = countryData?.ISDCode || "";
                            obj.Nationality = countryData?.CountryCode || "";
                            obj.PassportNo = showPassport(countryData?.CountryId) && obj?.PassportNo ? obj?.PassportNo : ""
                            obj.PassportExpDate = showPassport(countryData?.CountryId) && obj?.PassportExpDate ? obj?.PassportExpDate : null
                            obj.tempExpiryDate = showPassport(countryData?.CountryId) && obj?.tempExpiryDate ? obj?.tempExpiryDate : ""
                            obj.PassportIssueDate = showPassport(countryData?.CountryId) && obj?.PassportIssueDate ? obj?.PassportIssueDate : null
                            obj.tempPassportIssueDate = showPassport(countryData?.CountryId) && obj?.tempPassportIssueDate ? obj?.tempPassportIssueDate : ""
                            obj.PassportIssueCountryCode = (showPassport(countryData?.CountryId) && countryData?.CountryCode) || "";
                            obj.PAN = isinternationalhotel ? obj.PAN : "";
                        }

                        else if (name === 'TitleId') {
                            const titleData = titleList?.find((find: any) => find?.value === Number(e.target.value));
                            obj.TitleId = titleData?.value || 0;
                            obj.Title = titleData?.label || '';
                            obj.Gender = titleData?.value === 1 ? 1 : 2
                        }

                        else if (name === "PassportIssueCountryCode") {
                            obj[name] = e.target.value;
                        }

                        else {
                            obj[name] = Number(e.target.value);
                        }
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
        else if (coll === 'child') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 2) {
                        if (name === 'CountryId') {
                            const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));
                            obj.CountryId = countryData?.CountryId || 0;
                            obj.CountryCode = countryData?.CountryCode || "";
                            obj.CountryName = countryData?.CountryName || "";
                            obj.CellCountryCode = countryData?.ISDCode || "";
                            obj.Nationality = countryData?.CountryCode || "";
                            obj.PassportNo = showPassport(countryData?.CountryId) && obj?.PassportNo ? obj?.PassportNo : ""
                            obj.PassportExpDate = showPassport(countryData?.CountryId) && obj?.PassportExpDate ? obj?.PassportExpDate : null
                            obj.tempExpiryDate = showPassport(countryData?.CountryId) && obj?.tempExpiryDate ? obj?.tempExpiryDate : ""
                            obj.PassportIssueDate = showPassport(countryData?.CountryId) && obj?.PassportIssueDate ? obj?.PassportIssueDate : null
                            obj.tempPassportIssueDate = showPassport(countryData?.CountryId) && obj?.tempPassportIssueDate ? obj?.tempPassportIssueDate : ""
                            obj.PassportIssueCountryCode = (showPassport(countryData?.CountryId) && countryData?.CountryCode) || "";
                            obj.PAN = isinternationalhotel ? obj?.PAN : "";
                        }

                        else if (name === 'TitleId') {
                            const titleData = titleList?.find((find: any) => find?.value === Number(e.target.value));
                            obj.TitleId = titleData?.value || 0;
                            obj.Title = titleData?.label || '';
                            obj.Gender = titleData?.value === 1 ? 1 : 2
                        }

                        else if (name === "PassportIssueCountryCode") {
                            obj[name] = e.target.value;
                        }

                        else {
                            obj[name] = Number(e.target.value);
                        }
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
    }
    const handleLeadRadio = (coll: any, name: any, e: any, id: any, roomiondex: any) => {
        setFormError({});
        if (coll === 'adult') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    obj.LeadPassenger = false
                    if (obj?.id === id && obj.PaxType === 1) {
                        if (name === 'LeadPassenger') {
                            obj.LeadPassenger = e.target.checked
                        }
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
    }
    //#endregion

    //#region fullname textbox on change for collection
    const handleOnChange = (coll: any, name: any, value: any, id: any, roomiondex: any) => {
        setFormError({});
        if (coll === 'adult') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 1) {
                        obj[name] = value;
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
        else if (coll === 'child') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 2) {
                        obj[name] = value;
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
    }
    //#endregion

    //#region date of birth and expiry date on chnage for collection
    const handleDateChange = (coll: any, name: any, e: any, id: any, roomiondex: any) => {
        setFormError({});
        if (coll === 'adult') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 1) {
                        if (name === 'tempExpiryDate') {
                            obj.PassportExpDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
                            obj.tempExpiryDate = e.target.value ? formatDate(e.target.value) : "";
                        }
                        else if (name === 'tempPassportIssueDate') {
                            obj.PassportIssueDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
                            obj.tempPassportIssueDate = e.target.value ? formatDate(e.target.value) : "";
                        }
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
        if (coll === 'child') {
            setInsertCollection((prevState: any) => {
                const updatedHotelPassenger = prevState?.[roomiondex]?.HotelPassenger?.map((obj: any) => {
                    if (obj?.id === id && obj.PaxType === 2) {
                        if (name === 'tempExpiryDate') {
                            obj.PassportExpDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
                            obj.tempExpiryDate = e.target.value ? formatDate(e.target.value) : "";
                        }
                        else if (name === 'tempPassportIssueDate') {
                            obj.PassportIssueDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
                            obj.tempPassportIssueDate = e.target.value ? formatDate(e.target.value) : "";
                        }
                    }
                    return obj;
                });

                const updatedInsertCollection = [...prevState];
                updatedInsertCollection[roomiondex].HotelPassenger = updatedHotelPassenger;
                return updatedInsertCollection;
            });
        }
    }
    //#endregion

    //#region other select on change
    const handleSelectChange = (e: any) => {
        setFormError({});
        const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));
        setFormValue((form: any) => ({
            ...form,
            CountryId: countryData?.CountryId || 0,
            CountryCode: countryData?.CountryCode || '',
            CountryName: countryData?.CountryName || '',
            CellCountryCode: countryData?.ISDCode || '',
            Nationality: countryData?.CountryCode || '',
        }));

    }
    //#endregion

    //#region contact detail on change
    const onChangeContactDetail = (name: any, value: any) => {
        setFormError({});
        setFormValue((form: any) => ({ ...form, [name]: value }));
    }
    //#endregion

    //#region other textbox on change
    const onChange = (name: any, value: any) => {
        setFormError({});
        setFormValue((form: any) => ({ ...form, [name]: value }));
        setInsertCollection(
            insertCollection?.map((obj: any) => {
                obj.HotelPassenger?.map((el: any) => (
                    el[name] = value
                ))
                return obj
            })
        )
    }
    //#endregion

    const handleCheckedAllPax = (name: any, e: any) => {
        setFormError({});
        const firstPaxPAN = insertCollection?.[0]?.HotelPassenger?.[0]?.PAN
        if (isValidPAN(firstPaxPAN)) {
            setFormValue((form: any) => ({ ...form, [name]: e.target.checked }));
            if (e.target.checked === true) {
                setInsertCollection(
                    insertCollection?.map((obj: any) => {
                        obj.HotelPassenger?.map((hotel: any) => {
                            hotel.PAN = hotel?.PAN?.trim()?.length > 0 ? hotel?.PAN : firstPaxPAN
                            return hotel;
                        })
                        return obj;
                    })
                )
            }
        }
        else {
            const error: any = {};
            error[`hotelPANAdult11`] = "Please enter valid PAN Number.";
            if (Object.keys(error)?.length > 0) {
                document.getElementById(Object.keys(error)[0])?.focus();
            }
            setFormError(error);
        }
    }

    //#region other checkbox on change
    const handleChecked = (name: any, e: any) => {
        setFormError({});
        setFormValue((form: any) => ({ ...form, [name]: e.target.checked, GSTNumber: '', GSTCompanyName: '', GSTCompanyContactNumber: '', GSTCompanyEmail: '', GSTCompanyAddress: '' }));
        setInsertCollection(
            insertCollection?.map((obj: any) => {
                obj.HotelPassenger?.map((el: any) => (
                    el.GSTNumber = '',
                    el.GSTCompanyName = '',
                    el.GSTCompanyEmail = '',
                    el.GSTCompanyContactNumber = '',
                    el.GSTCompanyAddress = ''
                ))
                return obj
            })
        )
    }
    //#endregion

    useEffect(() => {
        sessionStorage?.setItem('isinternationalhotel', hoteldata?.hotelDetails?.[0]?.countryCode?.toLowerCase() === 'in' ? 'false' : 'true');
    }, [hoteldata])
    return (
        <>
            <div className="detailContainer detailContainer_hotel">
                <form action="" method="">
                    {/* <!--Free medical Refund policy--> */}
                    <div className="features">

                        <div className="title pr">
                            <i className="fa-solid fa-user-group"></i>
                            <div>
                                <h4>Traveller Details</h4>
                                <p><b>NOTE : </b>Enter name as mentioned on your passport or Government approved ID proof. </p>
                            </div>
                        </div>
                        <div className="detailDiv pt-3">
                            <div id="travellerDetails">
                                {formError?.foreignNationality && <div className="text-danger text-center f-14">{formError?.foreignNationality}</div>}
                                {/* <!--Adult Traveller Form--> */}
                                {
                                    insertCollection?.map((objs: any, index: any) => (
                                        <Fragment key={index}>
                                            <h3 className="travellerTitle">Room {index + 1}</h3>
                                            {
                                                objs?.HotelPassenger?.filter((px: any) => px.PaxType === 1)?.map((el: any, indexa: any) => (
                                                    <Fragment key={indexa}>
                                                        <h3 className="travellerTitle">ADULT (12 yrs+)</h3>
                                                        <div key={`adult${el?.id}`} className="travellerDiv">
                                                            <h4 className="heading active">Adult {indexa + 1}</h4>
                                                            <div className="form">

                                                                <div className="row">
                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-check mb-3 travellerLead">
                                                                            <input className="form-check-input" type="radio" name={`LeadPassenger${index + 1}`} id={`lead${index + 1}${indexa + 1}`} checked={el?.LeadPassenger} value={el?.LeadPassenger} onChange={(e) => handleLeadRadio('adult', 'LeadPassenger', e, el?.id, index)} />
                                                                            <label className="form-check-label" htmlFor={`lead${index + 1}${indexa + 1}`}>Lead</label>
                                                                        </div>
                                                                        {formError[`lead${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`lead${index + 1}${indexa + 1}`]}</div>}
                                                                    </div>
                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelTravelerNameAdult${index + 1}${indexa + 1}`}
                                                                                value={el?.TravelerName}
                                                                                onChange={(e) => handleSelectSuggestion('adult', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Traveler Name </option>
                                                                                {
                                                                                    dropdownData?.travellerList?.map((list: any) => (
                                                                                        <option key={`travelerName${list?.UserMasterID}`} value={list?.UserMasterID}> {list?.FirstName} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelTravelerNameAdult${index + 1}${indexa + 1}`}>Traveler Name</label>
                                                                            {formError[`hotelTravelerNameAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelTravelerNameAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    {/* <div className="col-xl-2 col-lg-3 col-md-2 col-sm-3"> */}
                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelTitleSelectAdult${index + 1}${indexa + 1}`}
                                                                                value={el?.TitleId}
                                                                                onChange={(e) => handleSelect('adult', 'TitleId', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Title </option>
                                                                                {
                                                                                    titleList?.map((obj: any) => (
                                                                                        <option key={`title${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelTitleSelectAdult${index + 1}${indexa + 1}`}>Title</label>
                                                                            {formError[`hotelTitleSelectAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelTitleSelectAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelFirstNameAdult${index + 1}${indexa + 1}`}
                                                                                placeholder="First Name"
                                                                                value={el?.FirstName}
                                                                                onChange={(e) =>
                                                                                    e.target.value?.length <= 25 &&
                                                                                    handleOnChange('adult', 'FirstName', onlyAlphabets(e.target.value), el?.id, index)
                                                                                }
                                                                                maxLength={25}
                                                                            />
                                                                            <label htmlFor={`hotelFirstNameAdult${index + 1}${indexa + 1}`}>First Name</label>
                                                                            {formError[`hotelFirstNameAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelFirstNameAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelLastNameAdult${index + 1}${indexa + 1}`}
                                                                                placeholder="Last Name"
                                                                                value={el?.LastName}
                                                                                onChange={(e) =>
                                                                                    e.target.value?.length <= 25 &&
                                                                                    handleOnChange('adult', 'LastName', onlyAlphabets(e.target.value), el?.id, index)
                                                                                }
                                                                                maxLength={25}
                                                                            />
                                                                            <label htmlFor={`hotelLastNameAdult${index + 1}${indexa + 1}`}>Last Name</label>
                                                                            {formError[`hotelLastNameAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelLastNameAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-3">
                                                                        {
                                                                            genderList?.map((gender: any) => (
                                                                                <div key={`${gender?.label}${gender?.value}`} className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        name={`hotelAdult${index + 1}${indexa + 1}`}
                                                                                        id={`hotel${gender?.label}Adult${index + 1}${indexa + 1}`}
                                                                                        value={gender?.value}
                                                                                        checked={el?.Gender === gender?.value}
                                                                                        disabled
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor={`hotel${gender?.label}Adult${index + 1}${indexa + 1}`}>
                                                                                        {gender?.label}
                                                                                    </label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {formError[`hotelGenderAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelGenderAdult${index + 1}${indexa + 1}`]}</div>}
                                                                    </div>
                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelCountryAdult${index + 1}${indexa + 1}`}
                                                                                value={el?.CountryId}
                                                                                onChange={(e: any) => handleSelect('adult', 'CountryId', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Country </option>
                                                                                {
                                                                                    dropdownData?.countryList?.map((cnt: any) => (
                                                                                        <option key={`country${cnt?.CountryId}`} value={cnt?.CountryId} > {cnt?.CountryName} {cnt?.ISDCode ? `(${cnt?.ISDCode})` : ''} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelCountryAdult${index + 1}${indexa + 1}`}>Country</label>
                                                                            {formError[`hotelCountryAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelCountryAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelContactNoAdult${index + 1}${indexa + 1}`}
                                                                                placeholder="Mobile No"
                                                                                value={el?.Phoneno}
                                                                                onChange={(e) => handleOnChange('adult', 'Phoneno', onlyNumeric(e.target.value), el?.id, index)}
                                                                                maxLength={10}
                                                                            />
                                                                            {formError?.[`hotelContactNoAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError?.[`hotelContactNoAdult${index + 1}${indexa + 1}`]}</div>}
                                                                            <label htmlFor={`hotelContactNoAdult${index + 1}${indexa + 1}`}>Mobile Number</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="email"
                                                                                className="form-control"
                                                                                id={`hotelEmailIdAdult${index + 1}${indexa + 1}`}
                                                                                placeholder="Email"
                                                                                value={el?.Email}
                                                                                onChange={(e) => handleOnChange('adult', 'Email', e.target.value, el?.id, index)}
                                                                                maxLength={150}
                                                                            />
                                                                            {formError?.[`hotelEmailIdAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError?.[`hotelEmailIdAdult${index + 1}${indexa + 1}`]}</div>}
                                                                            <label htmlFor={`hotelEmailIdAdult${index + 1}${indexa + 1}`}>Email</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelAgeAdult${index + 1}${indexa + 1}`}
                                                                                value={el?.Age}
                                                                                onChange={(e) => handleSelect('adult', 'Age', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Age </option>
                                                                                {
                                                                                    ageList?.map((age: any) => (
                                                                                        <option key={`age${age?.value}`} value={age?.value} > {age?.label} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelAgeAdult${index + 1}${indexa + 1}`}>Age</label>
                                                                            {formError[`hotelAgeAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelAgeAdult${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        showPassport(el?.CountryId) &&
                                                                        <>
                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportNumberAdult${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport Number"
                                                                                        value={el?.PassportNo}
                                                                                        onChange={(e: any) => handleOnChange('adult', 'PassportNo', alphaNumeric(e.target.value), el?.id, index)}
                                                                                        maxLength={10}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportNumberAdult${index + 1}${indexa + 1}`}>Passport number</label>
                                                                                    {formError[`hotelPassportNumberAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportNumberAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportIssueDateAdult${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport Issuance Date"
                                                                                        value={el.tempPassportIssueDate}
                                                                                        onChange={(e: any) => handleDateChange('adult', 'tempPassportIssueDate', e, el?.id, index)}
                                                                                        onClick={(e: any) => {
                                                                                            e.preventDefault();

                                                                                            const input: any = document.getElementById(
                                                                                                `hotelPassportIssueDateAdult${index + 1}${indexa + 1}`
                                                                                            ) as HTMLInputElement | null;

                                                                                            input?.showPicker();
                                                                                        }}

                                                                                        onKeyDown={(e: any) => {
                                                                                            e.preventDefault();

                                                                                            const input: any = document.getElementById(
                                                                                                `hotelPassportIssueDateAdult${index + 1}${indexa + 1}`
                                                                                            ) as HTMLInputElement | null;

                                                                                            input?.showPicker();
                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportIssueDateAdult${index + 1}${indexa + 1}`}>Passport Issuance Date</label>
                                                                                    {formError[`hotelPassportIssueDateAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportIssueDateAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportExpiryAdult${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport expiry date"
                                                                                        value={el.tempExpiryDate}
                                                                                        onChange={(e) => handleDateChange('adult', 'tempExpiryDate', e, el?.id, index)}
                                                                                        onClick={(e: any) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportExpiryAdult${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker()
                                                                                        }}
                                                                                        onKeyDown={(e) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportExpiryAdult${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker()
                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportExpiryAdult${index + 1}${indexa + 1}`}>Passport expiry date</label>
                                                                                    {formError[`hotelPassportExpiryAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportExpiryAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <select
                                                                                        className="form-select"
                                                                                        id={`hotelPassportIssueCountryCodeAdult${index + 1}${indexa + 1}`}
                                                                                        value={el?.PassportIssueCountryCode}
                                                                                        onChange={(e) => handleSelect('adult', 'PassportIssueCountryCode', e, el?.id, index)}
                                                                                        disabled
                                                                                    >
                                                                                        <option value={""}> Select Issuance Country </option>
                                                                                        {
                                                                                            dropdownData?.countryList?.map((cnt: any) => (
                                                                                                <option key={`issuecountry${cnt?.CountryId}`} value={cnt?.CountryCode} > {cnt?.CountryName} {cnt?.CountryCode ? `(${cnt?.CountryCode})` : ''} </option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                    <label htmlFor={`hotelPassportIssueCountryCodeAdult${index + 1}${indexa + 1}`} className='bg-transparent'>Passport Issuance Country</label>
                                                                                    {formError[`hotelPassportIssueCountryCodeAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportIssueCountryCodeAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }

                                                                    {
                                                                        showPAN(el?.CountryId) &&
                                                                        <>
                                                                            {
                                                                                personcount?.PaxRooms?.reduce((sum: any, entry: any) => sum + entry?.Adults + entry?.Children, 0) > 1 && index === 0 && indexa === 0 ?
                                                                                    <div className="row">
                                                                                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                            <div className="form-floating mb-3">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    id={`hotelPANAdult${index + 1}${indexa + 1}`}
                                                                                                    placeholder="PAN No."
                                                                                                    value={el?.PAN}
                                                                                                    onChange={(e) => handleOnChange('adult', 'PAN', alphaNumeric(e.target.value).toUpperCase(), el?.id, index)}
                                                                                                    maxLength={150}
                                                                                                />
                                                                                                <label htmlFor={`hotelPANAdult${index + 1}${indexa + 1}`}>PAN No.</label>
                                                                                                {formError[`hotelPANAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPANAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                            <div className="checkBox">
                                                                                                <span className="form-check mb-2">
                                                                                                    <input
                                                                                                        className={`form-check-input`}
                                                                                                        type="checkbox"
                                                                                                        checked={formValue?.PanSameForAllPax || false}
                                                                                                        name='PanSameForAllPax' id="PanSameForAllPax"
                                                                                                        onChange={(e) => handleCheckedAllPax('PanSameForAllPax', e)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor="PanSameForAllPax">
                                                                                                        Same for All Pax
                                                                                                    </label>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                        <div className="form-floating mb-3">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                id={`hotelPANAdult${index + 1}${indexa + 1}`}
                                                                                                placeholder="PAN No."
                                                                                                value={el?.PAN}
                                                                                                onChange={(e) => handleOnChange('adult', 'PAN', alphaNumeric(e.target.value)?.toUpperCase(), el?.id, index)}
                                                                                                maxLength={150}
                                                                                            />
                                                                                            <label htmlFor={`hotelPANAdult${index + 1}${indexa + 1}`}>PAN No.</label>
                                                                                            {formError[`hotelPANAdult${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPANAdult${index + 1}${indexa + 1}`]}</div>}
                                                                                        </div>
                                                                                    </div>
                                                                            }
                                                                        </>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                ))
                                            }
                                            {
                                                objs?.HotelPassenger?.filter((px: any) => px.PaxType === 2)?.map((el: any, indexa: any) => (
                                                    <Fragment key={indexa}>
                                                        <h3 className="travellerTitle">CHILD (2-12 Yrs)</h3>
                                                        <div key={`child${el?.id}`} className="travellerDiv">
                                                            <h4 className="heading active">Child {indexa + 1}</h4>
                                                            <div className="form">

                                                                <div className="row">

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelTravelerNameChild${index + 1}`}
                                                                                value={el?.TravelerName}
                                                                                onChange={(e) => handleSelectSuggestion('child', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Traveler Name </option>
                                                                                {
                                                                                    dropdownData?.travellerList?.map((list: any) => (
                                                                                        <option key={`childtravelerName${list?.UserMasterID}`} value={list?.UserMasterID}> {list?.FirstName} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelTravelerNameChild${index + 1}`}>Traveler Name</label>
                                                                            {formError[`hotelTravelerNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`hotelTravelerNameChild${index + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelTitleSelectChild${index + 1}${indexa + 1}`}
                                                                                value={el?.TitleId}
                                                                                onChange={(e) => handleSelect('child', 'TitleId', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Title </option>
                                                                                {
                                                                                    titleList?.map((obj: any) => (
                                                                                        <option key={`title${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelTitleSelectChild${index + 1}${indexa + 1}`}>Title</label>
                                                                            {formError[`hotelTitleSelectChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelTitleSelectChild${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelFirstNameChild${index + 1}${indexa + 1}`}
                                                                                placeholder="First Name"
                                                                                value={el?.FirstName}
                                                                                onChange={(e) =>
                                                                                    e.target.value?.length <= 25 &&
                                                                                    handleOnChange('child', 'FirstName', onlyAlphabets(e.target.value), el?.id, index)
                                                                                }
                                                                                maxLength={25}
                                                                            />
                                                                            <label htmlFor={`hotelFirstNameChild${index + 1}${indexa + 1}`}>First Name</label>
                                                                            {formError[`hotelFirstNameChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelFirstNameChild${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelLastNameChild${index + 1}${indexa + 1}`}
                                                                                placeholder="Last Name"
                                                                                value={el?.LastName}
                                                                                onChange={(e) =>
                                                                                    e.target.value?.length <= 25 &&
                                                                                    handleOnChange('child', 'LastName', onlyAlphabets(e.target.value), el?.id, index)
                                                                                }
                                                                                maxLength={25}
                                                                            />
                                                                            <label htmlFor={`hotelLastNameChild${index + 1}${indexa + 1}`}>Last Name</label>
                                                                            {formError[`hotelLastNameChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelLastNameChild${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-3">
                                                                        {
                                                                            genderList?.map((gender: any) => (
                                                                                <div key={`${gender?.label}${gender?.value}`} className="form-check">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        name={`hotelChild${index + 1}${indexa + 1}`}
                                                                                        id={`hotel${gender?.label}Child${index + 1}${indexa + 1}`}
                                                                                        value={gender?.value}
                                                                                        checked={el?.Gender === gender?.value}
                                                                                        disabled
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor={`hotel${gender?.label}Child${index + 1}${indexa + 1}`}>
                                                                                        {gender?.label}
                                                                                    </label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {formError[`hotelGenderChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelGenderChild${index + 1}${indexa + 1}`]}</div>}
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id={`hotelAgeChild${index + 1}${indexa + 1}`}
                                                                                placeholder="First Name"
                                                                                value={el?.Age}
                                                                                // maxLength={3}
                                                                                disabled
                                                                            />
                                                                            <label htmlFor={`hotelAgeChild${index + 1}${indexa + 1}`}>Age</label>
                                                                            {formError[`hotelAgeChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelAgeChild${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                        <div className="form-floating mb-3">
                                                                            <select
                                                                                className="form-select"
                                                                                id={`hotelCountryChild${index + 1}${indexa + 1}`}
                                                                                value={el?.CountryId}
                                                                                onChange={(e) => handleSelect('child', 'CountryId', e, el?.id, index)}
                                                                            >
                                                                                <option value={0}> Select Country </option>
                                                                                {
                                                                                    dropdownData?.countryList?.map((cnt: any) => (
                                                                                        <option key={`country${cnt?.CountryId}`} value={cnt?.CountryId} > {cnt?.CountryName} {cnt?.ISDCode ? `(${cnt?.ISDCode})` : ''} </option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                            <label htmlFor={`hotelCountryChild${index + 1}${indexa + 1}`}>Country</label>
                                                                            {formError[`hotelCountryChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelCountryChild${index + 1}${indexa + 1}`]}</div>}
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        showPassport(el?.CountryId) &&
                                                                        <>
                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportNumberChild${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport Number"
                                                                                        value={el?.PassportNo}
                                                                                        onChange={(e) => handleOnChange('child', 'PassportNo', alphaNumeric(e.target.value), el?.id, index)}
                                                                                        maxLength={10}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportNumberChild${index + 1}${indexa + 1}`}>Passport number</label>
                                                                                    {formError[`hotelPassportNumberChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportNumberChild${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportIssueDateChild${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport Issuance Date"
                                                                                        value={el.tempPassportIssueDate}
                                                                                        onChange={(e) => handleDateChange('child', 'tempPassportIssueDate', e, el?.id, index)}
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportIssueDateChild${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker();
                                                                                        }}
                                                                                        onKeyDown={(e) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportIssueDateChild${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker();
                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportIssueDateChild${index + 1}${indexa + 1}`}>Passport Issuance Date</label>
                                                                                    {formError[`hotelPassportIssueDateChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportIssueDateChild${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        id={`hotelPassportExpiryChild${index + 1}${indexa + 1}`}
                                                                                        placeholder="Passport expiry date"
                                                                                        value={el.tempExpiryDate}
                                                                                        onChange={(e) => handleDateChange('child', 'tempExpiryDate', e, el?.id, index)}
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportExpiryChild${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker();
                                                                                        }}
                                                                                        onKeyDown={(e) => {
                                                                                            e.preventDefault();
                                                                                            const input: any = document.getElementById(`hotelPassportExpiryChild${index + 1}${indexa + 1}`);
                                                                                            input?.showPicker();
                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor={`hotelPassportExpiryChild${index + 1}${indexa + 1}`}>Passport expiry date</label>
                                                                                    {formError[`hotelPassportExpiryChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportExpiryChild${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                                <div className="form-floating mb-3">
                                                                                    <select
                                                                                        className="form-select"
                                                                                        id={`hotelPassportIssueCountryCodeChild${index + 1}${indexa + 1}`}
                                                                                        value={el?.PassportIssueCountryCode}
                                                                                        onChange={(e) => handleSelect('child', 'PassportIssueCountryCode', e, el?.id, index)}
                                                                                        disabled
                                                                                    >
                                                                                        <option value={""}> Select Issuance Country </option>
                                                                                        {
                                                                                            dropdownData?.countryList?.map((cnt: any) => (
                                                                                                <option key={`issuecountry${cnt?.CountryId}`} value={cnt?.CountryCode} > {cnt?.CountryName} {cnt?.CountryCode ? `(${cnt?.CountryCode})` : ''} </option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                    <label htmlFor={`hotelPassportIssueCountryCodeChild${index + 1}${indexa + 1}`} className='bg-transparent'>Passport Issuance Country</label>
                                                                                    {formError[`hotelPassportIssueCountryCodeChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPassportIssueCountryCodeChild${index + 1}${indexa + 1}`]}</div>}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }

                                                                    {
                                                                        showPAN(el?.CountryId) &&
                                                                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                                            <div className="form-floating mb-3">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    id={`hotelPANChild${index + 1}${indexa + 1}`}
                                                                                    placeholder="PAN No."
                                                                                    value={el?.PAN}
                                                                                    onChange={(e) => handleOnChange('child', 'PAN', alphaNumeric(e.target.value).toUpperCase(), el?.id, index)}
                                                                                    maxLength={150}
                                                                                />
                                                                                <label htmlFor={`hotelPANChild${index + 1}${indexa + 1}`}>PAN No.</label>
                                                                                {formError[`hotelPANChild${index + 1}${indexa + 1}`] && <div className="text-danger f-14">{formError[`hotelPANChild${index + 1}${indexa + 1}`]}</div>}
                                                                            </div>
                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                ))
                                            }
                                        </Fragment>
                                    ))
                                }

                                {/* <!--Adult Traveller Form--> */}


                                {/* <!--Booking details will be send your Contact Details --> */}
                                <div className="travellerDiv">
                                    <div className="title">
                                        <h4>Contact Details</h4>
                                    </div>
                                    <div className="form">
                                        <div className="row">

                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                <div className="form-floating mb-3">
                                                    <select
                                                        className="form-select"
                                                        id={`CountryId`}
                                                        name='CountryId'
                                                        value={formValue?.CountryId}
                                                        onChange={(e) => handleSelectChange(e)}
                                                    >
                                                        <option value={0}> Select Country </option>
                                                        {
                                                            dropdownData?.countryList?.map((cnt: any) => (
                                                                <option key={`contactcountry${cnt?.CountryId}`} value={cnt?.CountryId} > {cnt?.CountryName} {cnt?.ISDCode ? `(${cnt?.ISDCode})` : ''} </option>
                                                            ))
                                                        }
                                                    </select>
                                                    <label htmlFor={`CountryId`}>Country Code</label>
                                                    {formError[`CountryId`] && <div className="text-danger f-14">{formError[`CountryId`]}</div>}
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id={`FirstName`}
                                                        name='FirstName'
                                                        placeholder="First Name"
                                                        value={formValue?.FirstName || ''}
                                                        onChange={(e) =>
                                                            e.target.value?.length <= 25 &&
                                                            onChangeContactDetail(e.target.name, onlyAlphabets(e.target.value))
                                                        }
                                                        maxLength={25}
                                                    />
                                                    <label htmlFor={`FirstName`}>First Name</label>
                                                    {formError[`FirstName`] && <div className="text-danger f-14">{formError[`FirstName`]}</div>}
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id={`LastName`}
                                                        name='LastName'
                                                        placeholder="Last Name"
                                                        value={formValue?.LastName || ''}
                                                        onChange={(e) =>
                                                            e.target.value?.length <= 25 &&
                                                            onChangeContactDetail(e.target.name, onlyAlphabets(e.target.value))
                                                        }
                                                        maxLength={25}
                                                    />
                                                    <label htmlFor={`LastName`}>Last Name</label>
                                                    {formError[`LastName`] && <div className="text-danger f-14">{formError[`LastName`]}</div>}
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="MobileNo"
                                                        placeholder="Mobile No"
                                                        name='MobileNo'
                                                        maxLength={12}
                                                        value={formValue?.MobileNo || ''}
                                                        onChange={(e) => onChangeContactDetail(e.target.name, onlyNumeric(e.target.value))}
                                                    />
                                                    <label htmlFor="MobileNo">Mobile No</label>
                                                    {formError[`MobileNo`] && <div className="text-danger f-14">{formError[`MobileNo`]}</div>}
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        id="Email"
                                                        placeholder="email"
                                                        name='Email'
                                                        maxLength={120}
                                                        value={formValue?.Email || ''}
                                                        onChange={(e) => onChangeContactDetail(e.target.name, e.target.value)}
                                                    />
                                                    {formError?.Email && <div className="text-danger f-14">{formError?.Email}</div>}
                                                    <label htmlFor="Email">Email</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--Booking details will be send your Contact Details --> */}


                                {/* <!--Use GST for this booking --> */}
                                <div className="travellerDiv">
                                    <div className="heading">
                                        <span className="form-check">
                                            <input
                                                className={`form-check-input ${formValue?.IsGST ? '' : 'collapsed'}  `}
                                                type="checkbox"
                                                checked={formValue?.IsGST || null}
                                                name='IsGST' id="IsGST"
                                                onChange={(e) => handleChecked('IsGST', e)}
                                                data-bs-toggle="collapse" data-bs-target="#usegst" />
                                            <label className="form-check-label" htmlFor="IsGST">
                                                Use GST for this booking
                                            </label>
                                        </span>
                                    </div>

                                    <div id="usegst" className={`accordion-collapse collapse ${formValue?.IsGST ? 'show' : ''} `}>
                                        <div className="form">
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="GSTNumber"
                                                            placeholder="GST No"
                                                            name='GSTNumber'
                                                            value={formValue?.GSTNumber || ''}
                                                            onChange={(e) => onChange(e.target.name, e.target.value)}
                                                            maxLength={15}
                                                        />
                                                        <label htmlFor="GSTNumber">GST Number</label>
                                                        {formError?.GSTNumber && <div className="text-danger f-14">{formError?.GSTNumber}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="GSTCompanyName"
                                                            placeholder="GST Company Name"
                                                            name='GSTCompanyName'
                                                            value={formValue?.GSTCompanyName || ''}
                                                            onChange={(e) => onChange(e.target.name, alphaNumericWithSpace(e.target.value))}
                                                            maxLength={50}
                                                        />
                                                        <label htmlFor="GSTCompanyName">GST Company Name</label>
                                                        {formError?.GSTCompanyName && <div className="text-danger f-14">{formError?.GSTCompanyName}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="GSTCompanyContactNumber"
                                                            placeholder="GST Company Contact"
                                                            name='GSTCompanyContactNumber'
                                                            value={formValue?.GSTCompanyContactNumber || ''}
                                                            onChange={(e) => onChange(e.target.name, onlyNumeric(e.target.value))}
                                                            maxLength={12}
                                                        />
                                                        <label htmlFor="GSTCompanyContactNumber">GST Company Contact</label>
                                                        {formError?.GSTCompanyContactNumber && <div className="text-danger f-14">{formError?.GSTCompanyContactNumber}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            id="GSTCompanyEmail"
                                                            placeholder="GST Company Email"
                                                            name='GSTCompanyEmail'
                                                            value={formValue?.GSTCompanyEmail || ''}
                                                            onChange={(e) => onChange(e.target.name, e.target.value)}
                                                            maxLength={150}
                                                        />
                                                        <label htmlFor="GSTCompanyEmail">GST Company Email</label>
                                                        {formError?.GSTCompanyEmail && <div className="text-danger f-14">{formError?.GSTCompanyEmail}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="GSTCompanyAddress"
                                                            placeholder="GST Company Address"
                                                            name='GSTCompanyAddress'
                                                            value={formValue?.GSTCompanyAddress || ''}
                                                            onChange={(e) => onChange(e.target.name, e.target.value)}
                                                            maxLength={150}
                                                        />
                                                        <label htmlFor="GSTCompanyAddress">GST Company Address</label>
                                                        {formError?.GSTCompanyAddress && <div className="text-danger f-14">{formError?.GSTCompanyAddress}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--Use GST for this booking --> */}
                            </div>
                        </div>
                    </div>
                    {/* <!--Free medical Refund policy--> */}
                    <button type='button' className="btn continueBtn" onClick={() => handleContinue(false, hoteldata)} >Continue</button>
                </form>

            </div>
        </>
    )
}

export default HotelAddTravellerForm
